import { IMPORT_PROJECT } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'
import { OptionalMain } from './OptionalMain'

const OpenImportModal: React.FC = () => {
  const dispatch = useDispatch()
  const [params] = useSearchParams()

  useEffect(() => {
    dispatch(
      // @ts-expect-error
      openModal(IMPORT_PROJECT, {
        defaultUrl: params.get('url'),
        immediately: params.get('immediately') === 'true',
      })
    )
  }, [])

  return null
}

export const Import: React.FC = () => (
  <AuthenticatedWrapper>
    <OpenImportModal />
    <OptionalMain />
  </AuthenticatedWrapper>
)
